import { RiskScope } from '../enums/risk-scope.enum';

const regFac = (riskScope: RiskScope) => new RegExp(`\\b${riskScope}\\b`, 'i');

export const globalRegex = regFac(RiskScope.Global);
export const hybridRegex = regFac(RiskScope.Hybrid);
export const localRegex = regFac(RiskScope.Local);

export const riskScopeRegexes = {
  [RiskScope.Global]: globalRegex,
  [RiskScope.Hybrid]: hybridRegex,
  [RiskScope.Local]: localRegex,
};
